/**
 * Student Config API service
 * Handles HTTP requests to the student profile endpoint
 */

import { api } from '@/lib/api';
import type { StudentConfig } from '@/types/studentConfig';

/**
 * Fetch the authenticated student's access mode configuration
 * Returns student ID, allowed mode (serverless/mcp-only/both), and completed sessions count
 * @returns Promise resolving to StudentConfig object
 */
export async function getStudentConfig(): Promise<StudentConfig> {
  const response = await api.get<StudentConfig>('/students/me');
  return response.data;
}
